export default __webpack_public_path__ + "static/media/ti.1ef041fb.svg";